/**
 * Work ID priority display: consistent label and Bootstrap variant for badges.
 * Matches server normalization: Low, Medium, High (title case).
 */

export const PRIORITY_OPTIONS = [
  { value: 'Low', label: 'Low' },
  { value: 'Medium', label: 'Medium' },
  { value: 'High', label: 'High' },
] as const;

export type PriorityVariant = 'success' | 'warning' | 'danger' | 'secondary';

/**
 * Returns Bootstrap badge variant for the priority.
 * High = danger (red), Medium = warning (amber), Low = success (green).
 */
export function getPriorityVariant(priority: string | null | undefined): PriorityVariant {
  if (priority == null || priority === '') return 'secondary';
  const u = priority.trim().toUpperCase();
  if (u === 'HIGH') return 'danger';
  if (u === 'MEDIUM') return 'warning';
  if (u === 'LOW') return 'success';
  return 'secondary';
}

/**
 * Returns display label in title case (Low, Medium, High).
 */
export function formatPriority(priority: string | null | undefined): string {
  if (priority == null || priority === '') return '–';
  const p = priority.trim();
  if (!p) return '–';
  const u = p.toUpperCase();
  if (u === 'HIGH') return 'High';
  if (u === 'MEDIUM') return 'Medium';
  if (u === 'LOW') return 'Low';
  return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
}

/** True when priority is Low or Medium (any common casing). */
export function isLowOrMediumPriority(priority: string | null | undefined): boolean {
  if (priority == null || !String(priority).trim()) return false;
  const u = String(priority).trim().toUpperCase();
  return u === 'LOW' || u === 'MEDIUM';
}
